import React, { Component } from 'react';
import { ClockCircleOutlined, DislikeOutlined, LikeOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

export default class RendererStatus extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.valueAsIcon(),
        };
    }

    valueAsIcon() {
        switch (this.props.value) {
            case 1:
                //return <Icon type="unlock" style={{ fontSize: '16px' }} />
                break;
            case 5:
                return <span title='Pending'><ClockCircleOutlined style={{ fontSize: '16px' }} /></span>
            case 10:
                return <span title='Pending 2nd-approver'><ClockCircleOutlined style={{ color: '#FF0000', fontSize: '16px' }} /></span>
            case 20:
                return <span title='Rejected'><DislikeOutlined style={{ color: '#FF0000', fontSize: '16px' }} /></span>
            case 50:
                return <span title='Approved'><LikeOutlined style={{ color: '#008000', fontSize: '16px' }} /></span>
            case 100:
                return <span title='Error' ><ExclamationCircleOutlined style={{ color: '#FF0000', fontSize: '16px' }} /></span>
            case 999:
                return <span title='Workflow action pending'><ClockCircleOutlined spin style={{ fontSize: '16px' }} /></span>
            default:
                break;
        }
    }

    render() {
        return <span>
            {this.state.value}
        </span>;
    }
}
